/** @prettier */
import { once } from '../../utils/function-helper';
import { AnalyticsCategories } from '../afterBlocks/analytics/analyticsCategories';
import events from '../events';
import { initBuyButtonsInBlock, initSubscribing } from '../helpers/cta';
import { getSwiperScript } from '../helpers/thirdPartyScripts';
import affiliate from './affiliate';

const renderSlider = async (slider) => {
  const { Swiper } = await getSwiperScript();
  if (!Swiper) {
    return false;
  }
  const mySwiper = new Swiper(`.${slider.class}`, slider);
  return mySwiper;
};

export const initPromoSliderEventHandlerOnce = once(() => {
  window.addEventListener(
    events.promoSlider.init,
    async (event) => {
      const { slider, block, data, translations } = event.detail;

      await renderSlider(slider);

      initBuyButtonsInBlock({
        analyticsCategory: AnalyticsCategories.PROMO,
        data,
        block,
        translations,
      });
      initSubscribing({
        analyticsCategory: AnalyticsCategories.PROMO,
        block,
        data,
      });
      affiliate({ block });
    },
    false
  );
});

export default ({ data, block, translations }) => {
  initPromoSliderEventHandlerOnce();
  const { sliders = [] } = data;
  if (sliders.length > 0) {
    const result = /promoSlider-([a-z|\d]{24})/.exec(block.id.toString());
    const id = result ? result[1] : 'nullish';
    const slider = sliders.find(
      (slider) => slider.class === `promo-slider-container-${id}`
    );
    if (!slider) {
      return;
    }
    const {
      promoSlider: { init },
    } = events;
    window.dispatchEvent(
      new CustomEvent(init, {
        detail: {
          slider,
          block,
          data,
          translations,
        },
      })
    );
  }
};
